import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { updateRegistrationType } from "../actions";

const RegistrationForm = ({ data, onSave, onCancel, isNew, currencySymbol }) => {
  const [name, setName] = useState(data?.name || '');
  const [amount, setAmount] = useState(data?.amount || '');
  const [description, setDescription] = useState(data?.description || '');

  const handleAmountChange = (e) => {
    const val = e.target.value;
    if (val === '' || /^\d*\.?\d*$/.test(val)) {
      setAmount(val);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave({ name, amount, description });
  };

  return (
    <div className="registration_configuration_wrapper col-xs-12 col-sm-6">
      <div className="card-header clearfix">
        <div className="header-text pull-left">REGISTRATION OPTION</div>
      </div>

      <div className="registration_option_form_content add-padding-15">
        <form className="form-horizontal" onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="col-sm-3 control-label">Name</label>
            <div className="col-sm-9">
              <input type="text" className="form-control" value={name} onChange={(e) => setName(e.target.value)} required maxLength={100} />
            </div>
          </div>

          <div className="form-group">
            <label className="col-sm-3 control-label">Flat Fee ({currencySymbol})</label>
            <div className="col-sm-9">
              <input
                type="text"
                className="form-control"
                value={amount}
                onChange={handleAmountChange}
                placeholder="0.00"
                required
                maxLength={10}
              />
            </div>
          </div>

          <div className="form-group">
            <label className="col-sm-3 control-label">Description</label>
            <div className="col-sm-9">
              <textarea className="form-control" value={description} rows={5} onChange={(e) => setDescription(e.target.value)} maxLength={500} />
            </div>
          </div>

          <div className="form-actions add-margin-top-20 clearfix">
            <div className="pull-right">
              {isNew ? (
                <button type="submit" className="button btsp_orange_button">Create Option</button>
              ) : (
                <>
                  <button type="button" className="btn btn-default btn-cancel" onClick={onCancel}>Cancel</button>
                  <button type="submit" className="button btsp_orange_button">Save Changes</button>
                </>
              )}
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

const ReadOnlyView = ({ data, onEditClick, currencySymbol }) => (
  <div className="registration_configuration_wrapper read-only col-xs-12 col-sm-6">
    <div className="card-header clearfix">
      <div className="header-text pull-left">REGISTRATION OPTION</div>
    </div>
    <div className="registration_option_summary_content add-padding-15">
      <h3 className="summary-name">{data?.name}</h3>
      <p className="summary-fee">{currencySymbol}{data?.amount}</p>
      <p className="summary-description text-muted">{data?.description}</p>
      <div className="summary-actions add-margin-top-20 clearfix">
        <div className="pull-left">
          <button className="button btsp_white_button" onClick={onEditClick}>Edit</button>
        </div>
      </div>
    </div>
  </div>
);

const RegistrationOption = () => {
  const dispatch = useDispatch();
  const registration_type = useSelector(state => state.registration_type);
  const currencySymbol = useSelector(state => state.currency_symbol || '$');
  const [isEditing, setIsEditing] = useState(false);
  const isNew = !registration_type || !registration_type.name;

  const handleSave = (updatedData) => {
    dispatch(updateRegistrationType(updatedData));
    setIsEditing(false);
  };

  if (isNew) {
    return <RegistrationForm data={registration_type} onSave={handleSave} isNew={true} currencySymbol={currencySymbol} />;
  }

  return isEditing ? (
    <RegistrationForm data={registration_type} onSave={handleSave} onCancel={() => setIsEditing(false)} isNew={false} currencySymbol={currencySymbol} />
  ) : (
    <ReadOnlyView data={registration_type} onEditClick={() => setIsEditing(true)} currencySymbol={currencySymbol} />
  );
};

export default RegistrationOption;